import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React from 'react';
import { CONTEXT_KEY } from './constants';
export const SlotContext =
// @ts-expect-error
self[CONTEXT_KEY] || /*#__PURE__*/React.createContext({
  type: 'uninitialized'
});

// When building the OOI plugin and host separately, it is likely that they will
// use different instances of this module. This means that the context will not
// be shared between the two. To solve this issue, a global instance is
// created to ensure that the context is shared between the OOI host and plugin.
// @ts-expect-error
self[CONTEXT_KEY] = SlotContext;
export const SlotContextProvider = props => {
  const children = props.children,
    slotProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(SlotContext.Provider, {
    value: {
      type: 'initialized',
      value: slotProps
    }
  }, children);
};
//# sourceMappingURL=SlotContextProvider.js.map